import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function RegisterPage() {
    const [form, setForm] = useState({ name: "", email: "", password: "" });
    const [loading, setLoading] = useState(false);
    const { register } = useAuth();
    const nav = useNavigate();
    const submit = async (e) => {
        e.preventDefault(); setLoading(true);
        const res = await register(form.email, form.password, form.name);
        setLoading(false);
        if (res.ok) { toast.success("Cuenta creada"); nav("/cuenta"); } else toast.error(res.error);
    };
    const inp = "w-full border border-sandLight bg-white rounded-md px-4 py-3 text-sm outline-none focus:border-ink";
    return (
        <div className="mx-auto max-w-md px-4 py-16">
            <p className="text-eyebrow">Cuenta</p>
            <h1 className="font-display text-4xl mt-2 mb-8">Crear cuenta</h1>
            <form onSubmit={submit} className="space-y-4">
                <input required placeholder="Nombre completo" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inp} />
                <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inp} />
                <input required type="password" minLength={6} placeholder="Contraseña (min 6)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={inp} />
                <button disabled={loading} className="btn-ink w-full">{loading ? "Creando…" : "Registrarme"}</button>
            </form>
            <p className="text-sm text-ink/60 mt-6 text-center">¿Ya tienes cuenta? <Link to="/login" className="text-ink underline">Inicia sesión</Link></p>
        </div>
    );
}
